const PAYLOAD_FORMAT_INDICATOR = "000201";
const CRC_FIELD = "6304";
const CRC_LENGTH = 4;

/** CRC-16/CCITT-FALSE (poly 0x1021, init 0xFFFF), the EMVCo QR checksum, over the UTF-8 bytes. */
export function crc16Ccitt(input: string): string {
  let crc = 0xffff;
  for (const byte of new TextEncoder().encode(input)) {
    crc ^= byte << 8;
    for (let bit = 0; bit < 8; bit++) {
      crc = crc & 0x8000 ? ((crc << 1) ^ 0x1021) & 0xffff : (crc << 1) & 0xffff;
    }
  }
  return crc.toString(16).toUpperCase().padStart(CRC_LENGTH, "0");
}

/**
 * Whether a scanned string is an EMVCo merchant-presented payload (what every Bre-B QR is): it opens with the
 * format indicator and ends with a valid checksum over everything before it. A URL QR or a misread is never
 * sent to the backend.
 */
export function isEmvQrPayload(raw: string): boolean {
  if (!raw.startsWith(PAYLOAD_FORMAT_INDICATOR)) return false;
  const crcStart = raw.length - CRC_LENGTH;
  if (crcStart < PAYLOAD_FORMAT_INDICATOR.length + CRC_FIELD.length) return false;
  if (raw.slice(crcStart - CRC_FIELD.length, crcStart) !== CRC_FIELD) return false;
  return crc16Ccitt(raw.slice(0, crcStart)) === raw.slice(crcStart).toUpperCase();
}
